import React, { useState, useEffect, useCallback, Fragment } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import LaunchIcon from "@material-ui/icons/Launch";
import GetAppIcon from "@material-ui/icons/GetApp";

//Custom Component
import NormalDialog from "../../../Dialog/NormalDialog";
import TransimittalEditDocumentItem from "./TransmittalEditDocumentItem";

// Material-UI Icon
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { webViewerSaveAnnotation } from "../../../../global/webViewerSaveAnnotation";

import { rfiDetailFormStyle } from "../../../../styles/jss/components/RFI/rfiDetailFormStyle";

const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));
const store = require("store");
const TransmittalDocumentItem = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    submissionValue,
    setSubmissionValue,
    viewFileAction,
    downloadFileAction,
    deleteAtthConfirmAction,
    isNew,
    editable,
    userStageAction,
  } = props;
  const [editRow, setEditRow] = useState({});
  const [selectEditDialogOpen, setSelectEditDialogOpen] = useState(false);
  const editAtth = (obj) => {
    setEditRow(obj);
    selectEditHandleOpen();
  };

  // Handle Dialog open and close
  const selectEditHandleOpen = () => {
    setSelectEditDialogOpen(true);
  };

  const selectEditHandleClose = () => {
    setSelectEditDialogOpen(false);
  };

  const editDialogBtn = [
    {
      buttonName: "Close",
      buttonFunction: selectEditHandleClose,
      chooseFile: false,
    },
  ];

  return (
    <Fragment>
      <NormalDialog
        open={selectEditDialogOpen}
        dialogTitle={`Edit Record`}
        formContent={
          <TransimittalEditDocumentItem
            submissionValue={submissionValue}
            setSubmissionValue={setSubmissionValue}
            setSelectEditDialogOpen={setSelectEditDialogOpen}
            editRow={editRow}
            setEditRow={setEditRow}
          />
        }
        size={"lg"}
        height={700}
        button={editDialogBtn}
        handleClose={selectEditHandleClose}
      />
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table
            className={classes.table}
            size="small"
            aria-label="simple table"
          >
            <TableHead>
              <TableRow style={{ background: "rgba(0, 75, 225, 0.4)" }}>
                <TableCell align="left" style={{ width: "3%" }}></TableCell>
                <TableCell align="left">Submission Material</TableCell>
                <TableCell align="left">Ref No.</TableCell>
                <TableCell align="left">Date</TableCell>
                <TableCell align="left">Desciption</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {submissionValue.documents.length > 0 &&
                submissionValue.documents.map((obj) => (
                  <TableRow key={obj.id}>
                    <TableCell
                      component="th"
                      scope="obj"
                      style={{ width: "10%" }}
                    >
                      <div style={{ display: "flex" }}>
                        <Tooltip title="Edit Row">
                          <IconButton
                            aria-label="edit"
                            onClick={() => {
                              editAtth(obj);
                            }}
                            className={classes.itemBtn}
                            disabled={isNew || editable ? false : true}
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Row">
                          <IconButton
                            aria-label="delete"
                            onClick={() => {
                              deleteAtthConfirmAction(
                                obj.id,
                                obj.file_seq,
                                !("files" in obj) ? "" : obj.files.atth_seq
                              );
                            }}
                            className={classes.itemBtn}
                            disabled={isNew || editable ? false : true}
                          >
                            <DeleteForeverIcon />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </TableCell>
                    <TableCell>
                      {obj.material}
                      {obj.files && obj.type !== "hardcopy" && (
                        <Tooltip title="View File">
                          <IconButton
                            aria-label="view_file"
                            onClick={() => {
                              let file_cat =
                                isNew || !("atth_seq" in obj)
                                  ? "master"
                                  : "xmtl";
                              let file_seq =
                                isNew || !("atth_seq" in obj)
                                  ? obj.files.file_seq
                                  : obj.atth_seq;
                              viewFileAction(
                                file_cat,
                                file_seq,
                                obj.files.filename
                              );
                            }}
                            disabled={
                              obj.files.extension !== null &&
                              obj.files.extension.toLowerCase() === "pdf"
                                ? false
                                : true
                            }
                            className={classes.itemBtn}
                          >
                            <LaunchIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                      {!isNew && obj.type !== "hardcopy" && obj.files && (
                        <Tooltip title="Download File">
                          <IconButton
                            aria-label="download_file"
                            className={classes.itemBtn}
                            onClick={() => {
                              let file_cat =
                                isNew || !("atth_seq" in obj)
                                  ? "master"
                                  : "xmtl";
                              let file_seq =
                                isNew || !("atth_seq" in obj)
                                  ? obj.files.file_seq
                                  : obj.atth_seq;
                              downloadFileAction(file_cat, file_seq);
                            }}
                            className={classes.itemBtn}
                          >
                            <GetAppIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>
                    <TableCell align="left">{obj.ref_no}</TableCell>
                    <TableCell align="left">
                      {obj.atthDate !== null
                        ? moment(obj.atthDate).format("MM/DD/YYYY")
                        : []}
                    </TableCell>
                    <TableCell align="left">{obj.description}</TableCell>
                  </TableRow>
                ))}

              {userStageAction.IS_ATTACHMENT_READABLE === "N" &&
              !isNew &&
              submissionValue.documents.length === 0 ? (
                <TableRow style={{ height: 10 }}>
                  <TableCell
                    colSpan={12}
                    style={{ textAlign: "center", color: "red" }}
                  >
                    <h3>No right to access attachment</h3>
                  </TableCell>
                </TableRow>
              ) : (
                ""
              )}
              {((submissionValue.documents.length === 0 &&
                userStageAction.IS_ATTACHMENT_READABLE === "Y") ||
                (submissionValue.documents.length === 0 && isNew)) && (
                <TableRow style={{ height: 10 }}>
                  <TableCell colSpan={12} style={{ textAlign: "center" }}>
                    No Records of Data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Fragment>
  );
};

export default TransmittalDocumentItem;
